import { storedAppointmentLifecycleReceipts } from './useAppointmentLifecycleGuard';

export interface FutureSeriesRescheduleCommand {
  appointmentId: string;
  coachPersonId?: string;
  expectedSeriesMutationVersion: number;
  expectedVersion: number;
  memberPersonId?: string;
  // MEN-5652: the member's optional note to the coach; absent when blank.
  reason?: string;
  seriesId: string;
  startAt: string;
  viewerTimezone: string;
}

export type RetainedFutureSeriesSelection =
  | { kind: 'ambiguous' }
  | { kind: 'none' }
  | { command: FutureSeriesRescheduleCommand; kind: 'selected' };

export const futureSeriesRescheduleCommand = (
  bytes: string | undefined,
): FutureSeriesRescheduleCommand | null => {
  if (!bytes) return null;
  try {
    const command = JSON.parse(
      bytes,
    ) as Partial<FutureSeriesRescheduleCommand> & { scope?: unknown };
    return command.scope === 'this_and_following' &&
      typeof command.appointmentId === 'string' &&
      typeof command.seriesId === 'string' &&
      Number.isInteger(command.expectedSeriesMutationVersion) &&
      (command.expectedSeriesMutationVersion ?? 0) > 0 &&
      Number.isInteger(command.expectedVersion) &&
      (command.expectedVersion ?? 0) > 0 &&
      typeof command.startAt === 'string' &&
      typeof command.viewerTimezone === 'string'
      ? (command as FutureSeriesRescheduleCommand)
      : null;
  } catch {
    return null;
  }
};

export const retainedFutureSeriesRescheduleCommand = ({
  coachPersonId,
  memberPersonId,
}: {
  coachPersonId: string | undefined;
  memberPersonId: string | undefined;
}): RetainedFutureSeriesSelection => {
  if (!coachPersonId || !memberPersonId) return { kind: 'none' };
  const commands = storedAppointmentLifecycleReceipts('member-reschedule')
    .filter(
      ({ status }) =>
        status === 'submitting' ||
        status === 'pending' ||
        status === 'confirmed',
    )
    .map(({ bytes }) => futureSeriesRescheduleCommand(bytes))
    .filter(
      (command): command is FutureSeriesRescheduleCommand =>
        command?.coachPersonId === coachPersonId &&
        command.memberPersonId === memberPersonId,
    );
  if (commands.length > 1) return { kind: 'ambiguous' };
  const [command] = commands;
  return command ? { command, kind: 'selected' } : { kind: 'none' };
};
